export default "__VITE_ASSET__Co_EMsTs__"